module.exports = __webpack_public_path__ + "static/img/bi14.5b396f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/bi14.png
// module id = o41J
// module chunks = 0